import React from 'react';
import BarbershopCard from './BarbershopCard';

/**
 * Componente: BarbershopList (/components/BarbershopList.jsx)
 * Lista/Stack de barbearias
 */
const BarbershopList = ({ title, shops, onNavigate }) => (
  <section className="my-12">
    <h2 className="text-3xl font-bold text-gray-900 mb-6">{title}</h2>
    {shops.length > 0 ? (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {shops.map((shop) => (
          <BarbershopCard key={shop.id} shop={shop} onNavigate={onNavigate} />
        ))}
      </div>
    ) : (
      <p className="text-gray-500">Nenhuma barbearia encontrada.</p>
    )}
  </section>
);

export default BarbershopList;
